// 新增项目时配置的项目等级
export const ProjectLevelDic = [
  { level: "A" },
  { level: "B" },
  { level: "C" },
  { level: "D" }
];
